<template>
  <!-- name: '登录表单页/注册页' -->
  <div class="registerDefaultWrap">
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line1.svg"
      alt=""
      class="lineClass line1"
    />
    <img
      src="https://img.bbalt.cn/imgh5/userCenter/img_line2.svg"
      alt=""
      class="lineClass line2"
    />
    <img src="https://img.bbalt.cn/imgh5/logo_register_apply.png" alt="" class="logoClass" />
    <form action="" v-if="curType === '账号密码'" onsubmit="return false">
      <!-- 账号密码登录表单 -->
      <input type="text" placeholder="请输入账号" v-model="username" required />
      <input type="password" placeholder="请输入密码" v-model="password" required />
      <div class="checkBox">
        <input
          type="checkBox"
          required
          :checked="isChecked"
          @click="isChecked = !isChecked"
        />我已阅读并同意<span @click="showDialog = true">《需知协议》</span>
      </div>
      <button @click="handleLogin">登 录</button>
    </form>

    <!-- 注册表单 -->
    <form v-else>
      <input type="text" placeholder="请输入账号" v-model="username" required />
      <input type="password" placeholder="请输入密码" v-model="password" required />
      <div class="checkBox">
        <input
          type="checkBox"
          required
          :checked="isChecked"
          @click="isChecked = !isChecked"
        />我已阅读并同意<span @click="showDialog = true">《需知协议》</span>
      </div>
      <button type="button" @click="handleRegister">注 册</button>
    </form>
    <van-dialog
      v-model="showCheck"
      title="操作提示"
      confirmButtonColor="#00a392"
      @confirm="handleConfirm"
    >
      <p>请勾选同意协议</p>
    </van-dialog>
    <van-dialog v-model="showTips" title="操作提示" :show-confirm-button="false">
      注册成功，跳到登录页登录！
      <van-count-down
        ref="countDown"
        millisecond
        :time="3000"
        :auto-start="true"
        format="ss"
        @finish="onFinish"
      />
    </van-dialog>
    <van-dialog
      v-model="showDialog"
      title="操作提示"
      confirmButtonColor="#00a392"
    >
      <p>作为发布物品需求者，在信息发布之前我已经理解并同意以下说明条款：</p>
      <p>
        1）
        发布物品需求者所发布的需求信息均为真实、准确或者源于已知可靠的信息来源
      </p>
      <p>
        2）
        发布物品需求者如在发布需求之后得知任何关于信息不真实、不准确的情况，应于第一时间告知平台方并予以调整
      </p>
      <p>
        3）
        若发布物品需求者在已知的情况下提交和发布不真实的需求信息，平台方有权追究其法律责任。
      </p>
    </van-dialog>
  </div>
</template>

<script>
import { setToken } from "@/utils/localToken.js";
import { login, register } from "@/api/userCenter";
export default {
  components: {},
  data() {
    return {
      curType: "",
      username: "",
      password: "",
      isChecked: false,
      showCheck: false,
      showDialog: false,
      showTips:false
    };
  },
  created() {
    this.curType = localStorage.getItem("type");
  },
  methods: {
    async handleRegister() {
      if (this.username && this.password && this.isChecked) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(this.username)) {
          this.$toast.fail("账号需为手机号码！");
        } else {
          const { code, message } = await register({
            username: this.username,
            password: this.password,
          });
          if (code === 200) {
            this.showTips = true;
          } else {
            this.$toast.fail(message);
          }
        }
      } else if (!this.username) {
        this.$toast.fail("请输入账号");
      } else if (!this.password) {
        this.$toast.fail("请输入密码");
      } else {
        this.showCheck = true;
      }
    },
    async handleLogin() {
      if (this.username && this.password && this.isChecked) {
        const { code, content, message } = await login({
          username: this.username,
          password: this.password,
        });
        if (code === 200) {
          this.$toast.success('登录成功!');
          setToken(content);
          this.$router.push("/home");
        } else {
          this.$toast.fail(message);
        }
      }
    },
    handleConfirm() {
      this.isChecked = !this.isChecked;
    },
    onFinish() {
      this.showTips = false;
      this.curType = "账号密码";
      localStorage.setItem("type", this.curType);
      this.username = "";
      this.password = "";
      this.isChecked = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.registerDefaultWrap {
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #fbf0f6, rgba(255, 255, 255, 0) 30%),
    linear-gradient(215deg, #e9f1f8, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #fff, #fff 45%);
  overflow: auto;
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  font-family: PingFang-SC, PingFang-SC;
  .lineClass {
    position: absolute;
    &.line1 {
      top: -26px;
      right: 0px;
      width: 238px;
      height: 162px;
    }
    &.line2 {
      bottom: 347px;
      left: 2px;
      width: 117px;
      height: 57px;
    }
  }
  .logoClass {
    width: 240px;
    height: 130px;
    margin-top: 161px;
  }
  form {
    margin-top: 56px;
    display: flex;
    flex-flow: column;
    align-items: center;
    input {
      margin-top: 40px;
      width: 678px;
      height: 96px;
      background: #f5f5f5;
      border-radius: 47px;
      border: none;
      padding-left: 48px;
      &::placeholder {
        font-size: 30px;
        font-weight: 400;
        color: #999999;
      }
    }
    .checkBox {
      margin-top: 32px;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 32px;
      height: 32px;
      input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("https://img.bbalt.cn/imgh5/icon_unselect.png");
        background-size: 30px 30px;
        background-repeat: no-repeat;
        width: 30px !important;
        height: 30px !important;
        outline: none;
        box-sizing: border-box;
        padding: 0px;
        border-radius: 0px;
        border: none;
        background-color: #d8d8d8;
        margin-top: 0px;
        margin-right: 16px;
        margin-left: 8px;
      }
      input[type="checkbox"]:checked:checked {
        background: url("https://img.bbalt.cn/imgh5/icon_select.svg") no-repeat center;
        background-size: 100% 100%;
      }
    }
    button {
      width: 678px;
      height: 96px;
      background: #fe74ae;
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
      margin-top: 32px;
    }
  }
}
.van-dialog p {
  padding: 20px;
  line-height: 40px;
  text-align: center;
}
::v-deep .van-dialog__header {
  color: #000;
}
::v-deep .van-dialog__content{
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin: 30px 0px;
}
</style>
